import styles from "../../style.module.scss";
import useStore from "../../store/store";
import formatPrice from "../../utils/format-price";
import {Fragment, useEffect, useState} from "react";
import {translateRateName} from "../../utils/rate-name";

function Step2({car,number, rates, promoFinishDate, promoPriceGrid, priceGrid, links}) {
    const [open, setOpen] = useState(true);
    const startDate = useStore((state) => state.startDate)
    const currentRate = useStore((state) => state.currentRate)
    const setCurrentRate = useStore((state) => state.setCurrentRate)
    const ratesHide = useStore((state) => state.ratesHide)
    const setRatesHide = useStore((state) => state.setRatesHide)
    const lang = useStore((state) => state.lang)

    const t = {
        selectTariff: lang === 'en' ? 'Select a tariff' : 'Выберите тариф',
        daysFrom: lang === 'en' ? 'days: from ' : 'суток: от ',
        days: lang === 'en' ? 'days' : 'суток',
        perKm: lang === 'en' ? '1 km' : 'За 1км',
        showMore: lang === 'en' ? 'Show more' : 'Смотреть подробнее'
    };

    const getListPrices = (id) => {
        const rateId = parseInt(id);

        if (!priceGrid) {
            return [];
        }
        if ((rateId === 1 || rateId === 2) && !!promoFinishDate && !!promoPriceGrid) {
            const date = new Date(promoFinishDate);
            if (date >= startDate) {
                return promoPriceGrid;
            }
        }
        if (priceGrid[rateId]) {
            return priceGrid[rateId];
        }

        return [];
    }
    const canShowRate = (rateId) => {
        let match = false;
        if (!!startDate) {
            const rate = rates?.filter((rate) => parseInt(rate.id) === rateId)?.[0];
            if (rate) {
                const periods = rate?.periods;
                if (periods) {
                    for (let i = 0; i < periods.length; i++) {
                        const [start, finish] = periods[i].split('-');
                        const startPeriod = new Date(parseInt(start) * 1000);
                        const finishPeriod = new Date(parseInt(finish) * 1000);
                        if (startDate >= startPeriod && startDate <= finishPeriod) {
                            if  (getListPrices(parseInt(rate.id))?.length) {
                                match = true;
                            }
                        }
                    }
                }
            }
        }

        return match;
    }
    const getActiveRates = () => {
        return rates?.filter((rate) => canShowRate(parseInt(rate.id)))
    }

    const getCurrentValue = () => {
        const rate = rates?.filter((rate) => parseInt(rate.id) === currentRate)?.[0];

        return translateRateName(rate?.name, lang) || '';
    }

    useEffect(() => {
        const activeRates = getActiveRates();
        if (!!activeRates.length) {
            if (activeRates.length === 1) {
                //setRatesHide(true)
                const activeRateId = parseInt(activeRates[0].id);
                if (currentRate !== activeRateId) {
                    setCurrentRate(parseInt(activeRateId));
                }
            } else {
                //setRatesHide(false)
                if (!currentRate) {
                    const activeRateId = parseInt(activeRates[0].id);
                    setCurrentRate(parseInt(activeRateId));
                } else {
                    const hasCurrentRateInActive = activeRates?.find((item)=>item.id === currentRate)
                    if (!hasCurrentRateInActive){
                        const activeRateId = parseInt(activeRates[0].id);
                        if (currentRate !== activeRateId) {
                            setCurrentRate(parseInt(activeRateId));
                        }
                    }
                    //may be
                }
            }
        } else {
            //setRatesHide(true)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [rates, startDate, setRatesHide, ratesHide, currentRate, setCurrentRate]);

    if (rates?.length && !ratesHide) {
        return (<div className={styles.newOrder__step}>
                <div className={`${styles.newOrder__stepHead} p-size`} onClick={() => setOpen(!open)}>
                    <div className={styles.newOrder__stepNumber}>
                        {number}
                    </div>
                    {t.selectTariff}
                    <div className={styles.newOrder__stepValue}>{getCurrentValue()}</div>
                    <div className={`${styles.newOrder__stepStatus} ${open && styles.open}`}/>
                </div>
                {
                    !!open && (
                        <div className={`${styles.newOrder__stepContent}`}>
                            {
                                rates.map((rate) => {
                                    const rateId = parseInt(rate.id)
                                    if (!canShowRate(rateId)) {

                                        return null;
                                    }
                                    return (<div key={rateId} className={styles.rate}>
                                        <div className={`${styles.name} p-size`} onClick={() => setCurrentRate(rateId)}>
                                            <div
                                                className={`${styles.checkbox} ${currentRate === rateId && styles.checked}`}/>
                                            {translateRateName(rate.name, lang)}
                                        </div>

                                        <div className={styles.prices}>
                                            {
                                                getListPrices(rateId)?.length > 1 &&  getListPrices(rateId)?.map((item, index) => {
                                                    return (
                                                        <div key={index} className={styles.price}>
                                                            {
                                                                (item.days_max === '999') && (
                                                                    <div>{t.daysFrom}{item.days_min}</div>)
                                                            }
                                                            {
                                                                (
                                                                    item.days_max !== '999') && (
                                                                    <div>{`${t.days}: ${item.days_min === '0' ? '1' : item.days_min} - ${item.days_max}`}</div>
                                                                )
                                                            }

                                                            <div>{formatPrice(item.price)}</div>
                                                        </div>
                                                    );
                                                })
                                            }
                                            {
                                                getListPrices(rateId)?.length === 1 &&  getListPrices(rateId)?.map((item, index) => {
                                                    return (
                                                        <Fragment key={index}>
                                                            <div  className={styles.price}>
                                                                {
                                                                    (item.days_max === '999') && (
                                                                        <div>
                                                                            {t.daysFrom}{item.days_min === '0' ? '1' : item.days_min}
                                                                        </div>)
                                                                }
                                                                <div>{formatPrice(item.price)}</div>
                                                            </div>
                                                            <div  className={styles.price}>
                                                                <div>{t.perKm}</div>
                                                                <div>{formatPrice(car.carkmprice)}</div>
                                                            </div>
                                                        </Fragment>


                                                    );
                                                })
                                            }
                                        </div>
                                        {
                                            getListPrices(rateId)?.length === 1 && !!rate?.text && (
                                                <div className={styles.rateDescription}>{rate.text}</div>)
                                        }
                                    </div>);
                                })
                            }
                            {
                                !!links?.rates?.link && (
                                    <a href={links.rates.link} className={styles.moreButton} target='_blank' rel='noreferrer'>
                                        {t.showMore}
                                    </a>)
                            }
                        </div>
                    )
                }

            </div>
        );
    }
    return null;
}

export default Step2;

